
import React, { Component } from "react";
export default function Bell(props){
	return (
<svg height={props.height} width={props.width} version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" xmlSpace="preserve">
	<title>Switch on</title>
	<g fill={props.fill} stroke={props.stroke} strokeLinecap="square" strokeWidth={props.strokewidth} >
		<path d="M6 18h12c3.311 0 6-2.689 6-6s-2.689-6-6-6h-12.039c-3.293.021-5.961 2.701-5.961 6 0 3.311 2.688 6 6 6zm12-10c-2.208 0-4 1.792-4 4s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4z" />
	</g>
</svg>
	)}


// WEBPACK FOOTER //
// ./src/assets/img/switch-on.jsx